module.exports = __webpack_public_path__ + "img/04王林南.0bbbcde5.jpg";